import React from 'react';
import { Box } from 'bloomer/lib/elements/Box';
import { Title } from 'bloomer/lib/elements/Title';
import { Button } from 'bloomer/lib/elements/Button';
import { Section } from 'bloomer/lib/layout/Section';
import styled from 'styled-components';
import ReactTable from 'react-table';

const FlexBox = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
`;
export default class IndividualHumanBreakdown extends React.Component {
	constructor() {
		super();
		this.state = {
			humanSort: 'all'
		};
		this.applyFilter = this.applyFilter.bind(this);
	}
	applyFilter(entry) {
		let filter = this.state.humanSort;

		if (filter === 'all') {
			return true;
		} else if (filter === 'volunteer') {
			return entry.walkerType === 'volunteer';
		} else if (filter === 'staff') {
			return entry.walkerType === 'staff';
		}
	}

	getColumns = (average) => [
		{
			Header: 'Name',
			accessor: 'name',
			Cell: ({ value }) => <p className="is-capitalized has-text-centered">{value}</p>,
			id: `name`
		},
		{
			Header: 'Average',
			accessor: (row) => (row.totalTime / row.days.length).toFixed(2),
			Cell: ({ value }) => <p className="has-text-centered">{value}</p>,
			id: `average`
		},
		{
			Header: 'Total Time',
			accessor: row => row.totalTime.toFixed(2),
			Cell: ({ value }) => <p className="has-text-centered">{value}</p>,
			id: `totalTime`
		},
	]
	

	render() {
		const { humanData } = this.props;
		const { humanSort } = this.state;
		const filteredData = humanData.filter(this.applyFilter);
		return (
			<Box className="on-print-own-page">
				<Title className="is-capialized" tag="h3">Individual Human Information:</Title>
				<FlexBox>
					<Button
						isColor="primary"
						onClick={() => {
							this.setState({ humanSort: 'all' });
						}}
					>
						All Humans
					</Button>
					<Button
						isColor="primary"
						onClick={() => {
							this.setState({ humanSort: 'staff' });
						}}
					>
						Staff
					</Button>
					<Button
						isColor="primary"
						onClick={() => {
							this.setState({ humanSort: 'volunteer' });
						}}
					>
						Volunteers
					</Button>
				</FlexBox>
				<Title tag="h4">{`${humanSort} Totals`}</Title>
				<Section>
				<ReactTable 
							data={filteredData}
							columns={this.getColumns(true)}
					/>
				</Section>
			</Box>
		);
	}
}
